import Cookies from 'js-cookie'

export const SSO = {
  agentId: 'vo-login-id',
  authId: 'vo-auth-id',
  employeeAccessToken: 'employee_accessToken',
  partnerAccessToken: 'partner_accessToken',
  refererAccessToken: 'referrerToken',
  userType: 'vo-user-type',
  userId: 'vo-userId',
  entity: 'entity',
  role: 'role',
}

const domain = '.starhealth.in'

const setCookiesData = async function (key, value, options = {}) {
  return await Cookies.set(key, value, {
    domain: domain,
    ...options,
  })
}

const getCookiesData = function (cookieName) {
  return Cookies.get(cookieName, { domain: domain })
}
const removeSSOCookies = function () {
  Object.values(SSO).map((eachCookieName) =>
    Cookies.remove(eachCookieName, { domain: domain })
  )
}

const getAccessToken = function () {
  return (
    Cookies.get(SSO.employeeAccessToken, { domain: domain }) ||
    Cookies.get(SSO.partnerAccessToken, { domain: domain })
  )
}

const getRefererAccessToken = function () {
  return Cookies.get(SSO.refererAccessToken, { domain: domain })
}

const getAgentId = () => Cookies.get(SSO.agentId, { domain: domain })
const getAuthId = () => Cookies.get(SSO.authId, { domain: domain })

const getUserType = () => Cookies.get(SSO.userId, { domain: domain })

const getSsoClientId = function () {
  return 'atom' //Cookies.get(SSO.ssoClientId);//for now it is hardcode for demo
}

const getUserId = function () {
  return Cookies.get(SSO.userId)
}
const getUserRole = function () {
  return Cookies.get(SSO.role)
}
const getUserProfile = () => {
  const key = `${getEntity()}_userProfile`;
  const raw = Cookies.get(key); // no options allowed in js-cookie v3+
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    // If cookie is corrupted or not JSON, fall back safely
    return {};
  }
};

const isCustomer = function () {
  return CookiesHelper.getUserRole()?.toString()?.toLowerCase() === 'customer'
}
const isLoggedIn = () => {
  return Boolean(getAccessToken())
}

const getEntity = function () {
  const employeeToken = Cookies.get(SSO.employeeAccessToken, { domain: domain })
  const partnerToken = Cookies.get(SSO.partnerAccessToken, { domain: domain })
  const referrerToken = Cookies.get(SSO.refererAccessToken, { domain: domain })
  const entity = Cookies.get(SSO.entity, { domain: domain })

  if (employeeToken) {
    return 'employee'
  } else if (partnerToken) {
    return 'partner'
  } else if (referrerToken) {
    return entity ?? 'partner'
  } else {
    return ''
  }
}

const CookiesHelper = {
  getUserProfile,
  getAccessToken,
  getSsoClientId,
  removeSSOCookies,
  getCookiesData,
  setCookiesData,
  isLoggedIn,
  getAgentId,
  getAuthId,
  getUserType,
  getUserId,
  getEntity,
  getRefererAccessToken,
  getUserRole,
  isCustomer,
}

export default CookiesHelper
